import { BREAKPOINTS } from './primary/breakpoints'
import PALETTE from './secondary/palette'

export default {
    ...PALETTE,
    breakpoints: BREAKPOINTS,
}
